import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'listMenu',
    'listMenuPopover',
    'popoverContent',
    'drawerItem',
    'drawerMenu',
    'headerLinksStyles',
])

const BraunMenu = helpers.defineMultiStyleConfig({
    baseStyle: {
        listMenu: {
            listContainer: {
                width: 'full',
                alignItems: 'center',
                gap: 'medium.lg',
                zIndex: 2,
                height: remCalc(72),
            },
            categoryTitle: {
                textStyle: 'body-small',
                fontWeight: 'light',
                color: 'text.inverse',
            },
        },
        listMenuPopover: {
            listMenuTriggerContainer: {
                display: 'flex',
                alignItems: 'center',
                textStyle: 'body-large',
                color: 'text.secondary',
                pr: remCalc(20),
            },
            listMenuContent: {
                width: '100vw',
                bg: 'background.default',
                display: 'flex',
                flexDirection: 'row',
                gap: 'small.base',
                justifyContent: 'center',
                zIndex: 2,
            },
            popoverOverlay: {
                pos: 'absolute',
                top: remCalc(72),
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: `rgba(0,0,0,0.5)`,
                backdropFilter: `blur(${remCalc(8)})`,
                zIndex: 1,
            },
        },
        popoverContent: {
            catContainer: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingX: remCalc(80),
                paddingY: remCalc(48),
                gap: 'small.base',
            },
            contentContainer: {
                w: '100%',
                maxW: 'container.xxl',
                flexDir: 'row',
                gap: 'small.base',
                alignItems: 'stretch',
                paddingY: remCalc(48),
            },
            productsContainer: {
                flex: '1',
                flexDir: 'row',
                gap: 'small.base',
                alignItems: 'stretch',
            },
            categoriesHeader: {
                textAlign: 'start',
                textStyle: 'body-small',
                fontWeight: 'light',
                color: 'text.secondary',
            },
            categoriesTitle: {
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            imageContainer: {
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                display: 'flex',
                flex: '1 0 0',
                padding: 'medium.lg',
                bgSize: 'cover',
                bgPos: 'center',
                maxW: {
                    base: remCalc(343),
                    sm: remCalc(736),
                    md: remCalc(488),
                    lg: remCalc(712),
                },
                maxH: {
                    base: remCalc(228),
                    sm: remCalc(490),
                    md: remCalc(325),
                    lg: remCalc(474),
                },
                aspectRatio: {
                    base: '343/228',
                    sm: '736/490',
                    md: '488/325',
                    lg: '712/474',
                },
            },
            imageTitleContainer: {
                flexDir: 'column',
                gap: 'small.base',
            },
            textTitle: {
                textStyle: 'body-large',
                fontWeight: 'light',
                alignSelf: 'stretch',
            },
            textSubtitle: {
                textStyle: 'head-small',
                fontWeight: 'medium',
                alignSelf: 'stretch',
            },
            drawerVariantContainer: {
                flexDir: 'column',
                w: '100%',
                gap: 'medium.base',
                alignSelf: 'stretch',
            },
            drawerContentSubContainer: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 'small.base',
                alignSelf: 'stretch',
            },
        },
        drawerMenu: {
            secondLevelContainer: {
                width: '100%',
                flexDirection: 'column',
                alignItems: 'flex-start',
            },
            secondLevelInnerContainer: {
                w: '100%',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 'medium.lg',
                alignSelf: 'stretch',
            },
            headerContainer: {
                flexDirection: 'column',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
            },
            goBackContainer: {
                py: {base: 'small.base', sm: 'small.base', md: 'medium.base', lg: 'medium.base'},
                px: 'small.base',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            goBackIcon: {
                w: 'iconsSize.small',
                h: 'iconsSize.small',
                cursor: 'pointer',
            },
            closeContainer: {
                w: 'iconsSize.large',
                h: 'iconsSize.large',

                alignItems: 'center',
                justifyContent: 'center',
                bg: 'background.dark',
                borderRadius: 'full',
                cursor: 'pointer',
            },
            contentContainer: {
                w: 'full',
                flexDir: {base: 'column', sm: 'column', md: 'row', lg: 'row'},
                justifyContent: 'space-between',
                paddingY: {base: 'unset', sm: 'unset', md: 'unset', lg: 'medium.base'},
                paddingX: 'small.base',
                gap: {base: remCalc(48), sm: remCalc(48), md: remCalc(48), lg: 'small.base'},
            },
            contentContainerHalf: {
                w: {base: '100%', sm: '100%', md: '100%', lg: '50%'},
                justifyContent: {base: 'center', sm: 'center', md: 'flex-end', lg: 'flex-start'},
                h: 'full',
            },
        },
        drawerItem: {
            itemContainer: {
                w: '100%',
                flexDir: 'column',
                alignItems: 'flex-start',
                gap: 'small.base',
                paddingY: 'small.base',
                paddingX: '0',
                alignSelf: 'stretch',
                borderBottom: '1px solid #E6E6E6',
            },
            innerContainer: {
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            },
            itemText: {
                flex: '1 0 0',
                textStyle: 'head-xsmall',
                fontWeight: 'light',
                color: 'text.inverse',
            },
            itemIcon: {
                display: 'flex',
                width: 'iconsSize.small',
                height: 'small.base',
                justifyContent: 'center',
                alignItems: 'center',
                aspectRatio: '1/1',
                color: 'white',
            },
        },
        headerLinksStyles: {
            headerLinksContainer: {
                w: '100%',
                flexDir: 'column',
                gap: 'medium.base',
                paddingTop: 'medium.lg',
            },
            greetingContainer: {
                w: '100%',
                gap: 'medium.base',
            },
            greetingText: {
                textStyle: 'body-small',
                fontWeight: 'light',
            },
            headerLinkItem: {
                flex: '1 0 0',
                textStyle: 'head-xxsmall',
                fontWeight: 'medium',
                color: 'text.inverse',
            },
            myAccountSection: {
                w: '100%',
                flexDir: 'column',
                gap: 'xsmall.base',
                alignItems: 'flex-start',
            },
        },
    },
})

export default BraunMenu
